import AuthLayout from "./AuthLayout.vue";
import MainLayout from "./MainLayout.vue";

export const layouts = {
  auth: AuthLayout,
  main: MainLayout,
};
